import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';

const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
if (!publishableKey) {
  throw new Error('REACT_APP_CLERK_PUBLISHABLE_KEY is missing from client/.env.local');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey}
      afterSignOutUrl="/"
      signInUrl="/"
      signUpUrl="/"
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);
